import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./layouts/tabs/tabs-routing.module').then((m) => m.routes),
        canActivate: [],
    },
];
